<template>
  <div>
    <h1>Data</h1>
    <p>{{message}}</p>
    <p><button v-on:click="doDelete">全データを削除する</button></p>
    <p><button v-on:click="doBackup">バックアップ</button></p>
    <p><input type="file" id="file-selector" @change="selectedFile"></p>
    <p><button v-on:click="doRestore" :disabled="file ===''">リストア</button></p>
    <div class="full__cvr fx_ctr hcenter" v-if="updating">
      <div class="compose__pot wbox">
        <div class="compose__pot--head fx_ctr">
          <p class="title">{{loadTitle}}</p>
        </div>
        <div class="compose__pot--inner">
          <p>Please wait a moment.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {importDB, exportDB} from "dexie-export-import";
import { saveAs } from "file-saver";


export default {
  data() {
    return {
      updating: false,
      file: '',
      message: '',
      loadTitle: ''
    }
  },
  methods: {
    doDelete: async function(){
      this.updating = true;
      this.loadTitle = 'Deleting All Datas...'
      await this.$db.delete().then(()=>{
          setTimeout(
            function() {
              this.updating = false;
            }.bind(this),
            500
          )
          window.location.reload(true);
      })
    },
    doBackup: async function(){
      // this.updating = true;
      const blob = await exportDB(this.$db);
      // console.log(blob);
      saveAs(blob, this.fileDate(new Date()) + '_potly_backup.json');
    },
    doRestore: async function(){
      this.loadTitle = 'Restoring DB'
      this.updating = true;
      // console.log(this.file);
      if(this.file.type === 'application/json'){
        await this.$db.delete();
        await importDB(this.file)
        window.location.reload()
      }else{
        this.updating = false;
        this.file = ''
        this.message = 'ファイルタイプが正しくありません。'
      }
      this.updating = false;
    },
    selectedFile(e){
      e.preventDefault();
      this.file = e.target.files[0];
    }
  }
}
</script>
